import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import './chunk-79dadc73.js';
import 'react';
import 'hoist-non-react-statics';
import { a as as } from './as-39ca1b5e.js';
import '@emotion/is-prop-valid';
import { bool as bool$1 } from 'prop-types';
import './chunk-afcdbe83.js';
import { c as bool } from './chunk-1128464e.js';
import Box from './Box.js';
var directions = ["row", "column", "rowReverse", "columnReverse"];
var wraps = ["nowrap", "wrap", "wrapReverse"];
var Flex = styled(Box).withConfig({
  displayName: "Flex",
  componentId: "sp5dv1-0"
})(["display:flex;&&&{", ";", ";}", ";"], bool("flex-direction", directions), bool("flex-wrap", wraps), theme("Flex")); // @ts-ignore

Flex.propTypes = {
  row: bool$1,
  column: bool$1,
  rowReverse: bool$1,
  columnReverse: bool$1,
  nowrap: bool$1,
  wrap: bool$1,
  wrapReverse: bool$1
};
var Flex$1 = as("div")(Flex);
export default Flex$1;